import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

type SidebarState = {
  isExpanded: Record<string, boolean>;
  showFavoritesOnly: Record<string, boolean>;
  expandedCategories: Record<string, boolean>;
  setIsExpanded: (userId: string, value: boolean) => void;
  setShowFavoritesOnly: (userId: string, value: boolean) => void;
  setExpandedCategory: (categoryId: string, value: boolean) => void;
};

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isExpanded: {},
      showFavoritesOnly: {},
      expandedCategories: {},
      setIsExpanded: (userId, value) =>
        set((state) => ({
          isExpanded: { ...state.isExpanded, [userId]: value },
        })),
      setShowFavoritesOnly: (userId, value) =>
        set((state) => ({
          showFavoritesOnly: { ...state.showFavoritesOnly, [userId]: value },
        })),
      setExpandedCategory: (categoryId, value) =>
        set((state) => ({
          expandedCategories: { ...state.expandedCategories, [categoryId]: value },
        })),
    }),
    {
      name: "sidebar-storage",
      storage: createJSONStorage(() => localStorage),
      partialize: (state) => ({
        isExpanded: state.isExpanded,
        showFavoritesOnly: state.showFavoritesOnly,
        expandedCategories: state.expandedCategories,
      }),
    },
  ),
);
